import * as api from "./api";

// login
export const login = async (params: { email: string; password: string }) => {
  const response: any = await api.post(
    `${process.env.REACT_APP_ADMIN_API_URL}/login`,
    params
  );
  return response;
};

// change password
export const changePassword = async (
  token: string,
  params: { oldPassword: string; password: string }
) => {
  try {
    api.setHeaderAuthorization(token);
    const response: any = await api.post(
      `${process.env.REACT_APP_ADMIN_API_URL}/change-password`,
      params
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// logout
export const logout = async (token: string) => {
  try {
    api.setHeaderAuthorization(token);
    const response = await api.get(
      `${process.env.REACT_APP_ADMIN_API_URL}/logout`,
      {}
    );
    api.setHeaderAuthorization(null);
    return response;
  } catch (error) {
    api.setHeaderAuthorization(null);
    throw error;
  }
};
